const CtaFuture = () => {
  return (
    <section
      data-testid="cta-future-section"
      className="py-20 bg-[var(--ac-red)] text-white relative overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.18) 0, transparent 40%), radial-gradient(circle at 80% 30%, rgba(245,192,86,0.25) 0, transparent 45%)",
        }}
      />
      <div className="ac-container relative z-10 text-center max-w-3xl">
        <h2
          className="text-white uppercase"
          style={{
            fontFamily: "var(--font-display)",
            fontSize: "clamp(1.75rem, 2.4vw, 2.375rem)",
            fontWeight: 500,
            lineHeight: "1.4em",
          }}
          data-testid="cta-future-heading"
        >
          Your Future <span className="font-display normal-case text-[#f5c056]">Begins Today!</span>
        </h2>
        <p
          className="mt-5"
          style={{
            fontFamily: "var(--font-body)",
            fontSize: "18px",
            fontWeight: 400,
            lineHeight: "1.4em",
            color: "rgba(255,255,255,0.95)",
          }}
        >
          Take the 6-minute Career Discovery Quiz and find the program that
          matches your strengths.
        </p>
        <div className="mt-8">
          <a
            href="/discovery-quiz"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-md bg-white text-[var(--ac-red)] font-bold hover:bg-[#f5c056] hover:text-[var(--ac-ink)] transition-all shadow-xl"
            data-testid="cta-quiz-btn"
          >
            Career Discovery Quiz
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaFuture;
